import React, {FunctionComponent} from 'react'
import {Moment} from 'moment'
import {useTranslation} from 'react-i18next'
import findValuesRecursive from '../../../../App/Helpers/findValuesRecursive'
import getTypes from '../getTypes'

type IProps = {
    result: any,
    from: Moment,
    to: Moment
}

const Header: FunctionComponent<IProps> = ({result, from, to}) => {
    const {t} = useTranslation()

    if (7 > to.diff(from, 'days')) {
        return <thead>
            <tr>
                <th/>
                <th/>
                <th className={'text-center'}>{t('Monday')}</th>
                <th className={'text-center'}>{t('Tuesday')}</th>
                <th className={'text-center'}>{t('Wednesday')}</th>
                <th className={'text-center'}>{t('Thursday')}</th>
                <th className={'text-center'}>{t('Friday')}</th>
                <th className={'text-center'}>{t('Saturday')}</th>
                <th className={'text-center'}>{t('Sunday')}</th>
                <th className={'text-center'}>{t('Total')}</th>
            </tr>
        </thead>
    }

    let types: string[] = getTypes(result)

    return <thead>
        <tr>
            <th/>
            <th/>
            {types.map((type) => <th>{type}</th>)}
        </tr>
    </thead>
}

export default Header
